import { LitElement, html, css, classMap, styleMap } from '@hh/global.js'

class HHScrollBar extends LitElement {
  static properties = {
    containerSelector: {
      type: String,
      reflect: true,
      attribute: 'container-selector',
    },
    thumbWidth: {
      type: Number,
    },
    thumbPosition: {
      type: Number,
    },
    visibleWidth: {
      type: Number,
    },
    totalWidth: {
      type: Number,
    },
    show: {
      type: Boolean,
    },
  }

  constructor() {
    super()
    this.show = false
  }

  connectedCallback() {
    super.connectedCallback()
    this.scrollContainer = document.querySelector(this.containerSelector)

    this.initThumbWidth()
    this.handleContainerResize()
    window.addEventListener('resize', this.initThumbWidth.bind(this))
    this.scrollContainer.addEventListener('scroll', this.onScroll.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.initThumbWidth)
    this.scrollContainer.removeEventListener('scroll', this.onScroll)
  }

  handleContainerResize() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = new ResizeObserver(this.initThumbWidth.bind(this));
    this.resizeObserver.observe(this.scrollContainer);
  }

  initThumbWidth() {
    this.show =
      this.scrollContainer.scrollWidth > this.scrollContainer.offsetWidth
    if (!this.show) return

    const { scrollWidth, offsetWidth } = this.scrollContainer
    this.visibleWidth = offsetWidth
    this.totalWidth = scrollWidth
    this.visibleRatio = this.visibleWidth / this.totalWidth

    this.thumbWidth = this.visibleRatio * 100
  }

  onScroll() {
    const { scrollLeft } = this.scrollContainer
    this.thumbPosition = scrollLeft * (100 / this.totalWidth)
  }

  render() {
    return html`
      <div
        class="${classMap({
          track: true,
          hide: !this.show,
        })}"
      >
        <div
          class="thumb"
          style=${styleMap({
            left: `${this.thumbPosition}%`,
            width: `${this.thumbWidth}%`,
          })}
        ></div>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      padding: var(--hh-scroll-container-padding, 0 1rem);
    }

    .track {
      position: relative;
      height: var(--hh-scroll-bar-height, 1px);
      width: 100%;
      background-color: var(--hh-scroll-container-color, #b8b8b8);
      overflow: hidden;
    }

    .thumb {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background-color: var(--hh-scroll-bar-color, #000);
    }

    .hide {
      display: none;
    }
  `
}

customElements.define('hh-scroll-bar', HHScrollBar)
